<template>
    <div class="content-i">

        <div class="content-box">
            <div class="element-wrapper">
                <div class="element-actions d-none d-sm-block">
                    <a class="btn btn-primary btn-sm" href="#">
                        <i class="os-icon os-icon-ui-22"></i>
                        <router-link tag="span" :to="`/copydesk/session/add`">
                            Add Session
                        </router-link>
                    </a>

                </div>
                <h6 class="element-header">
                    Copy Desk {{type}} Sessions
                </h6>
                <Loader v-if="isLoading" />
                <EmptyState v-else-if="sessions.length == 0" >
                    <div slot="empty_state_text">
                        No Sessions
                    </div>
                </EmptyState>
                <div class="element-box" v-else>
                    <div class="table-responsive">
                        <table class="table table-striped table-lightborder">
                            <thead>
                                <tr>
                                    <th>Session ID</th>
                                    <th>Status</th>
                                    <th>Channel</th>
                                    <th>Type</th>
                                    <th>Language</th>
                                    <th>Contributors</th>
                                    <th>Products</th>
                                    <th>Created</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="session in sessions">
                                    <td class="nowrap">
                                        {{session.code}}
                                    </td>
                                    <td class="nowrap capitalize" :class="formatStatus(session.status)">
                                        {{formatStatus(session.status)}}
                                    </td>
                                    <td class="nowrap"><img :src="session.channel_logo" height="16px" alt=""></td>
                                    <td class="nowrap capitalize">
                                      {{session.type}}
                                      <span v-if="session.is_import_session">
                                      <br> Import Session
                                      </span>
                                    </td>
                                    <td class="nowrap capitalize">{{session.language_name}}</td>
                                    <td>
                                        <div class="cell-image-list">
                                            <div v-for="contributor in formatContributors(session)" class="cell-img" :style="'background-image: url('+contributor.avatar+')'"></div>
                                            <!-- <div class="cell-img-more">
                                            + 5 more
                                        </div> -->
                                        </div>
                                    </td>

                                    <td>
                                        <h2>{{session.products}}</h2>

                                    </td>
                                    <td>
                                        {{session.created_at}}
                                    </td>
                                    <td>
                                        <router-link tag="a" :to="`/copydesk/sessions/${session.type}/${session.id_copydesk_session}`">
                                            View
                                        </router-link>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
                <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getSessions()" :offset="5"></Pagination>
            </div>

        </div>
    </div>
</template>

<script>
import axios from 'axios'
import Pagination from '@/components/common/Pagination'
import CommonFunctions from '@/mixins/common-functions.js'
import Loader from '@/components/common/Loader'
import EmptyState from '@/components/common/EmptyState'

export default {
  props: ['type'],
  mixins: [CommonFunctions],
  components: {
    Pagination,
    Loader,
    EmptyState
  },
  mounted: function () {
    this.getSessions()
  },
  data: function () {
    return {
      isLoading: true,
      sessions: [],
      pagination: {
        current_page: 1
      },
      statusFilters: [
        { name: 'All', key: '' },
        { name: 'Open', key: '1' },
        { name: 'Closed', key: '0' },
        { name: 'Cancelled', key: '3' }
      ]
    }
  },
  methods: {
    getSessions: function () {
      var self = this
      const url = '/copydesk/sessions?page=' + this.pagination.current_page
      let data = {
        page: this.pagination.current_page,
        type: this.type
      }
      self.isLoading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.sessions = response.data.sessions.data
          self.pagination = response.data.sessions
          self.isLoading = false
        })
        .catch(function (error) {
          console.log(error)
          self.isLoading = false
        })
    }
  },
  filters: {
    capitalize: function (value) {
      if (!value) return ''
      value = value.toString()
      return value.charAt(0).toUpperCase() + value.slice(1)
    }
  },
  watch: {
    type () {
      this.getSessions()
    }
  }
}
</script>

<style scoped>
.open {
  color: #75da62 !important;
}
.closed {
  color: #23b7e5 !important;
}
.cancelled {
  color: #ddd;
}
</style>
